import { Select as ThemedSelect, SelectProps as ThemedSelectProps } from 'theme-ui';
import { useLayoutEffect, useRef } from 'react';

export const CUSTOM_ARROW_PATH = 'M5 8L8 11L11 8';

export interface SelectProps extends ThemedSelectProps {}

const Select: React.FC<SelectProps> = ({ sx, ...props }) => {
  const select = useRef<HTMLSelectElement>(null);

  useLayoutEffect(() => {
    if (select.current?.parentNode) {
      const svg = select.current.parentNode.querySelector('svg');

      if (svg) {
        svg.setAttribute('role', 'img');
        const path = svg.querySelector('path');

        if (path) {
          svg.setAttribute('viewBox', '0 0 16 16');
          path.setAttribute('d', CUSTOM_ARROW_PATH);
        }
      }
    }
  });

  return (
    <ThemedSelect
      sx={{
        '& + svg': {
          width: '1em',
          height: '1em',
          ml: '-1.5em',
          fill: 'none',
          path: {
            stroke: 'currentColor',
            strokeLinecap: 'round',
            strokeLinejoin: 'round'
          }
        },
        ...sx
      }}
      {...props}
      ref={select}
    />
  );
};

export default Select;
